import { render, staticRenderFns } from "./GeneratedPayslips.vue?vue&type=template&id=06b8e8b4&"
import script from "./GeneratedPayslips.vue?vue&type=script&lang=js&"
export * from "./GeneratedPayslips.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedPayslips.vue?vue&type=style&index=0&id=06b8e8b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports